import axios from "axios";


export default  async function LoadAllMissionsFromDb(p_baseUrl,p_mission_type){
    try {
        let allMissionsResponse = await axios.post(p_baseUrl +'/admin/loadAllMissions',{mission_type:p_mission_type});
            if(allMissionsResponse.status === 200){
                return allMissionsResponse.data;
            }
            return 'error';
    } catch (error) {
        console.log("error While trying to LoadAllMissionsFromDb: " ,error);
        return 'error';
    }

}